(() => {
  if (customElements.get('lf-caneza-sale')) return;

  class LFCanezaSale extends HTMLElement {
    connectedCallback() {
      this._connectedAt = performance.now();
      this._serverNow = Number(this.dataset.now) * 1000;
      this._refresh = () => this.refresh();
      window.addEventListener('pageshow', this._refresh);
      document.addEventListener('visibilitychange', this._refresh);
      this.refresh();
    }

    refresh() {
      clearTimeout(this._timer);
      const start = Number(this.dataset.start) * 1000;
      const end = Number(this.dataset.end) * 1000;
      const serverNow = this._serverNow + performance.now() - this._connectedAt;
      const now = Math.max(Date.now(), serverNow);
      const currency = window.Shopify?.currency?.active;
      const active = Number.isFinite(now) && start > 0 && start < end && now >= start && now < end &&
        this.dataset.currency === 'USD' && (!currency || currency === 'USD');
      const offer = this.querySelector('[data-caneza-offer]');
      const fallback = this.querySelector('[data-caneza-fallback]');
      if (offer) offer.hidden = !active;
      if (fallback) fallback.hidden = active;
      this.hidden = !active && !fallback;
      if (active) this._timer = setTimeout(this._refresh, Math.min(end - now, 60000));
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      window.removeEventListener('pageshow', this._refresh);
      document.removeEventListener('visibilitychange', this._refresh);
    }
  }

  customElements.define('lf-caneza-sale', LFCanezaSale);
})();
